import PricingBoardStrategyActionDTO from '../../openapi/src/model/PricingBoardStrategyActionDTO'
import PricingBoardStrategyDTO from '../../openapi/src/model/PricingBoardStrategyDTO'
import PricingChannelStrategyActionDTO from '../../openapi/src/model/PricingChannelStrategyActionDTO'
import PricingChannelStrategyDTO from '../../openapi/src/model/PricingChannelStrategyDTO'
import PricingCompsetStrategyActionDTO from '../../openapi/src/model/PricingCompsetStrategyActionDTO'
import PricingCompsetStrategyDTO from '../../openapi/src/model/PricingCompsetStrategyDTO'
import PricingOccupancyConditionDTO from '../../openapi/src/model/PricingOccupancyConditionDTO'
import PricingOfferStrategyActionDTO from '../../openapi/src/model/PricingOfferStrategyActionDTO'
import PricingOfferStrategyConditionDTO from '../../openapi/src/model/PricingOfferStrategyConditionDTO'
import PricingOfferStrategyDTO from '../../openapi/src/model/PricingOfferStrategyDTO'
import PricingPickupConditionDTO from '../../openapi/src/model/PricingPickupConditionDTO'
import PricingRatesStrategyActionDTO from '../../openapi/src/model/PricingRatesStrategyActionDTO'
import PricingRatesStrategyConditionDTO from '../../openapi/src/model/PricingRatesStrategyConditionDTO'
import PricingRatesStrategyDTO from '../../openapi/src/model/PricingRatesStrategyDTO'
import PricingRoomStrategyActionDTO from '../../openapi/src/model/PricingRoomStrategyActionDTO'
import PricingRoomStrategyDTO from '../../openapi/src/model/PricingRoomStrategyDTO'

const factories = {
  BoardPricingStrategy: () =>
    PricingBoardStrategyDTO.constructFromObject({
      channel_ids: [],
      condition: {
        pricing_occupancy_condition: PricingOccupancyConditionDTO.prototype,
        pricing_pickup_condition: PricingPickupConditionDTO.prototype,
      },
      action: PricingBoardStrategyActionDTO.prototype,
    }),
  ChannelPricingStrategy: () =>
    PricingChannelStrategyDTO.constructFromObject({
      action: PricingChannelStrategyActionDTO.prototype,
    }),
  CompsetPricingStrategy: () =>
    PricingCompsetStrategyDTO.constructFromObject({
      channel_ids: [],
      board_ids: [],
      room_type_ids: [],
      condition: {
        pricing_occupancy_condition: PricingOccupancyConditionDTO.prototype,
        pricing_pickup_condition: PricingPickupConditionDTO.prototype,
      },
      action: PricingCompsetStrategyActionDTO.prototype,
    }),
  OffersPricingStrategy: () =>
    PricingOfferStrategyDTO.constructFromObject({
      condition: PricingOfferStrategyConditionDTO.prototype,
      action: PricingOfferStrategyActionDTO.prototype,
    }),
  RoomPricingStrategy: () =>
    PricingRoomStrategyDTO.constructFromObject({
      channel_ids: [],
      condition: {
        pricing_occupancy_condition: PricingOccupancyConditionDTO.prototype,
        pricing_pickup_condition: PricingPickupConditionDTO.prototype,
      },
      action: PricingRoomStrategyActionDTO.prototype,
    }),
  RatesPricingStrategy: () =>
    PricingRatesStrategyDTO.constructFromObject({
      channel_ids: [],
      action: PricingRatesStrategyActionDTO.prototype,
      condition: PricingRatesStrategyConditionDTO.prototype,
    }),
}

// NOTE: factories probably could/should live outside mixins.
// Because of the hurry and the only usage (by now) of this factory by
// its Vue component we will keep here by now... :S

class PricingStrategyFactory {
  static createStrategy(type) {
    let pricingStragy = factories[type]()

    if (type === 'RatesPricingStrategy') {
      pricingStragy.action.percent = true
      pricingStragy.condition.applicable_to = 'ALL'
      pricingStragy.condition.total_room_occupancy_format = 'PERCENTAGE'
    }

    if (type === 'OffersPricingStrategy') {
      pricingStragy.action.percent = true
      pricingStragy.condition.applicable_to = 'ALL'
      pricingStragy.condition.total_hotel_occupancy_format = 'PERCENTAGE'
    }
    if (type === 'ChannelPricingStrategy') {
      pricingStragy.action.percent = true
    }

    return Object.assign(pricingStragy, {
      type: type,
      order: 0,
      id: 0,
      is_new: true,
      is_ready: true,
    })
  }
}

var mixin = {
  methods: {
    initNewRule(rule) {
      this.$emit('rule-created', PricingStrategyFactory.createStrategy(rule.type))
    },
    mapRuleLabel: (label) => {
      const labels = new Map()
      labels.set('BoardPricingStrategy', 'Board')
      labels.set('ChannelPricingStrategy', 'Channel')
      labels.set('CompsetPricingStrategy', 'Compset')
      labels.set('OffersPricingStrategy', 'Offers')
      labels.set('RatesPricingStrategy', 'Rates')
      labels.set('RoomPricingStrategy', 'Room')

      if (labels.has(label)) {
        return labels.get(label)
      }
      return label
    },
  },
}

export default mixin
